<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.5 23.25a1 1 0 0 1-.46-.16L12 17.46l-7.03 5.63a.75.75 0 0 1-1.22-.59v-21A.75.75 0 0 1 4.5.75h15a.75.75 0 0 1 .75.75v21a.75.75 0 0 1-.75.75m-7.5-7.5q.26 0 .47.16l6.28 5.03V2.25H5.25v18.69l6.29-5.03q.2-.15.46-.16"/></svg>
</template>
